import { takeLatest } from 'redux-saga/effects';
import { getAccountPath } from '../../utils/firebase';
import { fetchRecentActivityRoutine } from '../routines';
import { fetchSaga } from './helper';

// function enrich(activity) {
//   return fetchDoc(getAccountPath(`/employees/${activity.userId}`))
//     .then((employee) => {
//       activity.employee = employee;
//       return activity;
//     })
//     .then(() => {
//       if (activity.taskId) {
//         return fetchDoc(getAccountPath(`/tasks/${activity.taskId}`))
//           .then((task) => {
//             activity.task = task;
//             return activity;
//           });
//       }
//
//       return activity;
//     });
// }

function* watchFetchRecentActivitySaga() {
  yield takeLatest(fetchRecentActivityRoutine.TRIGGER, fetchSaga(fetchRecentActivityRoutine, (payload) => getAccountPath('jobs', payload.jobId) + '/activity')); // TODO review url
}

export {
  watchFetchRecentActivitySaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/activity.js